import { render, staticRenderFns } from "./CookiesNotice.vue?vue&type=template&id=25e3cafc&scoped=true&"
import script from "./CookiesNotice.js?vue&type=script&lang=js&"
export * from "./CookiesNotice.js?vue&type=script&lang=js&"
import style0 from "./CookiesNotice.scss?vue&type=style&index=0&id=25e3cafc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e3cafc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAlert,VBtn})
